import { SET_FLOATING_IFRAME_DIMENSIONS, SET_TEASE_IFRAME_DIMENSIONS } from './ActionTypes';
export const setTeaseIframeDimensions = dimensions => ({
  type: SET_TEASE_IFRAME_DIMENSIONS,
  payload: dimensions
});
export const setFloatingIframeDimensions = dimensions => ({
  type: SET_FLOATING_IFRAME_DIMENSIONS,
  payload: dimensions
});